import { render, staticRenderFns } from "./article-add.vue?vue&type=template&id=3098eca5&"
import script from "./article-add.vue?vue&type=script&lang=js&"
export * from "./article-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3098eca5')) {
      api.createRecord('3098eca5', component.options)
    } else {
      api.reload('3098eca5', component.options)
    }
    module.hot.accept("./article-add.vue?vue&type=template&id=3098eca5&", function () {
      api.rerender('3098eca5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/contents-manage/article-add.vue"
export default component.exports